export const UPDATE_SIGNUP_PARAMS = "UPDATE_SIGNUP_PARAMS";

export const SUBMIT_SIGNUP_START = "SUBMIT_SIGNUP_START";
export const SUBMIT_SIGNUP_SUCCESS = "SUBMIT_SIGNUP_SUCCESS";
export const SUBMIT_SIGNUP_ERROR = "SUBMIT_SIGNUP_ERROR";

export const FETCH_PREVIEW_START = "FETCH_PREVIEW_START";
export const FETCH_PREVIEW_SUCCESS = "FETCH_PREVIEW_SUCCESS";
export const FETCH_PREVIEW_ERROR = "FETCH_PREVIEW_ERROR";

export const SEND_EMAIL_VERIFICATION_START = "SEND_EMAIL_VERIFICATION_START";
export const SEND_EMAIL_VERIFICATION_SUCCESS = "SEND_EMAIL_VERIFICATION_SUCCESS";
export const SEND_EMAIL_VERIFICATION_ERROR = "SEND_EMAIL_VERIFICATION_ERROR";

export const defaultSignupState = {
    signupParams: { 'shipping-sameas-billing': true },
    loading: 0, // 0 is false, larger than 0 is true (multiple loading happening)
    errors: {
        signup: null,
        preview: null,
        selectedPlans: null,
        verify: null,
    },
    success: false,
};

export const signupContextReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_SIGNUP_PARAMS:
            return {
                ...state,
                signupParams: { ...state.signupParams, ...payload },
            };
        case SUBMIT_SIGNUP_START:
            return {
                ...state,
                loading: state.loading + 1,
                errors: {
                    ...state.errors,
                    signup: null,
                },
            };
        case SUBMIT_SIGNUP_SUCCESS:
            return {
                ...state,
                success: true,
                loading: state.loading - 1,
            };
        case SUBMIT_SIGNUP_ERROR:
            return {
                ...state,
                loading: state.loading - 1,
                errors: {
                    ...state.errors,
                    signup: payload,
                },
            };
        case SEND_EMAIL_VERIFICATION_START:
            return {
                ...state,
                loading: state.loading + 1,
                errors: {
                    ...state.errors,
                    verify: null,
                },
            };
        case SEND_EMAIL_VERIFICATION_SUCCESS:
            return {
                ...state,
                loading: state.loading - 1,
                errors: {
                    ...state.errors,
                    verify: null,
                },
            };
        case SEND_EMAIL_VERIFICATION_ERROR:
            return {
                ...state,
                loading: state.loading - 1,
                errors: {
                    ...state.errors,
                    verify: payload,
                },
            };
        default:
            console.log("type: ", type);
            throw new Error();
    }
};
